import { Action } from '@ngrx/store';

export enum WikiReadersReportActionTypes {
  LoadAction = '[Wiki Readers Report] Load',
  LoadSuccessAction = '[Wiki Readers Report] Load Success',
  LoadFailureAction = '[Wiki Readers Report] Load Failure',
}

export class LoadAction implements Action {
  readonly type = WikiReadersReportActionTypes.LoadAction;

  constructor(
    public wikiId: string,
    public params: { page?: number; pageSize?: number } = {}
  ) {
  }
}

export class LoadSuccessAction implements Action {
  readonly type = WikiReadersReportActionTypes.LoadSuccessAction;

  constructor(
    public wikiId: string,
    public payload: any[]
  ) {
  }
}

export class LoadFailureAction implements Action {
  readonly type = WikiReadersReportActionTypes.LoadFailureAction;

  constructor(
    public wikiId: string,
    public payload: any
  ) {
  }
}

export type WikiReadersReportActions =
  | LoadAction
  | LoadSuccessAction
  | LoadFailureAction;
